import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'accountNumber',
})

export class AccountNumberPipe implements PipeTransform {
  transform(value: string): string {
    try {
      const leadingzero = value.toString().padStart(10, '0')
      const matched = /(\d*)(\d{5})$/.exec(leadingzero.toString())
      return matched ? matched[1] + '-' + matched[2] : value

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      return value
    }
  }
}